module.exports = __webpack_public_path__ + "img/dark.6d2ecf6c.png";